import HomeSection from "./sections/HomeSection";
import AdminPortal from "./sections/AdminPortal";
import { Redirect, Route, Switch } from "wouter";
import ConnectionsOverview from "./sections/ConnectionsOverview";
import SyncOverview from "./sections/Sync/SyncOverview";
import AddNewConnection from "./sections/NewConnection/AddNewConnection";
import UpdateConnection from "./sections/UpdateConnection";
import EasyflexAdministrationsConfiguration from "./sections/EasyflexAdministrationsConfiguration";
import Authentication from "./sections/Authentication";
import DryRunPreview from "./sections/DryRunPreview";
import SyncRunProgress from "./sections/SyncRunProgress";
import AuthorizationCodeRedirect from "./components/AuthorizationCodePage";
import DataStudio from "./sections/DataStudio/DataStudio";
import DataStudioApiKeys from "./sections/DataStudio/DataStudioApiKeys";
import { Toaster } from "react-hot-toast";
import { ApplicationInfoProvider } from "./context/ApplicationInfoContext";
import { useUser } from "./context/UserContext";
import { AuthenticatedLayout } from "./components/AuthenticatedLayout";
import { ApiKeySetupModal } from "./components/ApiKeySetupModal";
import { useOAuthPopupCallback } from "./hooks/useOAuthPopup";
import { isReadOnly } from "./config";

const SynchubRoutes = () => (
  <Switch>
    <Route path="/" component={() => <HomeSection />} />
    <Route path="/authenticatie" component={() => <Authentication />} />
    <Route path="/administraties" component={() => <EasyflexAdministrationsConfiguration />} />
    <Route path="/koppelingen" component={() => <ConnectionsOverview />} />
    <Route path="/nieuwe-koppeling">
      {isReadOnly ? (
        <Redirect to="/koppelingen" />
      ) : (
        <ApplicationInfoProvider>
          <AddNewConnection />
        </ApplicationInfoProvider>
      )}
    </Route>
    <Route path="/synchronisaties" component={() => <SyncOverview />} />
    <Route path="/proef-synchronisatie/:runId" component={() => <DryRunPreview />} />
    <Route path="/synchronisatie/:runId" component={() => <SyncRunProgress />} />
    <Route
      path="/koppeling/:connectionId"
      component={() => (isReadOnly ? <Redirect to="/koppelingen" /> : <UpdateConnection />)}
    />
    <Route path="/authorization-code" component={() => <AuthorizationCodeRedirect />} />
    <Route>Pagina niet gevonden!</Route>
  </Switch>
);

const DataStudioRoutes = () => (
  <Switch>
    <Route path="/" component={() => <Redirect to="/datastudio" />} />
    <Route path="/administraties" component={() => <EasyflexAdministrationsConfiguration />} />
    <Route path="/datastudio" component={() => <DataStudio />} />
    <Route path="/api-sleutels" component={() => <DataStudioApiKeys />} />
    <Route path="/authorization-code" component={() => <AuthorizationCodeRedirect />} />
    <Route>Pagina niet gevonden!</Route>
  </Switch>
);

const App = () => {
  const isOAuthPopupCallback = useOAuthPopupCallback();
  const { loading, error, user } = useUser();

  if (isOAuthPopupCallback) {
    return null;
  }

  if (window.location.pathname === "/admin") {
    return <AdminPortal />;
  }

  if (loading) return <div>Laden...</div>;
  if (error) return <div>Geen toegang: {error}</div>;

  const renderRoutes = () => {
    switch (user?.module) {
      case "sync_hub":
        return <SynchubRoutes />;
      case "data_studio":
        return <DataStudioRoutes />;
      default:
        return <div>Geen module geselecteerd!</div>;
    }
  };

  return (
    <AuthenticatedLayout>
      <Toaster />
      <ApiKeySetupModal />
      {renderRoutes()}
    </AuthenticatedLayout>
  );
};

export default App;
